import React from "react";

import * as SC from "./PrintMetricsValue.styled";

import useWinnerDot from "./hooks/useWinnerDot";
import useDataVizPercentage from "../../../PagesUser/Campaign/DataVisualization/hooks/useDataVizPercentage";

import PrintChannels from "../PrintChannels/PrintChannels";
import { numberFormat } from "../../../utils/Helpers";
import TargetMetric from "../TargetMetric/TargetMetric";
import { MetricTypes } from "../../../PagesUser/Campaign/DataVisualization/enums/metrics";

const PrintMetricsValue = ({
  showChannels,
  availableChannels = [],
  metricData,
  unit = "",
  isFloatNumber,
  minTarget = null,
  totalTarget = null,
  type = null
}) => {
  const { calculatePercentage } = useDataVizPercentage();
  const { renderDot } = useWinnerDot();

  let highestMetricValue = 0;
  metricData.forEach(({ value }) => {
    highestMetricValue = Math.max(highestMetricValue, value);
  });

  return (
    <SC.TargetMetricWrapper>
      <SC.ChannelMetricWrapper isFirstColumn={showChannels}>
        {showChannels && (
          <SC.Channels>
            <PrintChannels channels={availableChannels} />
          </SC.Channels>
        )}

        <SC.Metrics>
          {metricData.map((metric) => {
            const metricChannel = availableChannels.find((channel) => channel === metric.name);
            const percentage = `${calculatePercentage(metricData, metricChannel, isFloatNumber)} %`;
            const metricValue = metric.value ? numberFormat(metric.value) : "--";
            return (
              <SC.MetricsValue key={metric.name}>
                <SC.ValuePercentage>
                  {renderDot(type, metric.value, highestMetricValue)}
                  <SC.Value>{`${metricValue} ${metric.value ? unit : ""}`}</SC.Value>

                  {metric.value > 0 && type !== MetricTypes.CTR && (
                    <SC.Percentage>{percentage}</SC.Percentage>
                  )}
                </SC.ValuePercentage>
              </SC.MetricsValue>
            );
          })}
        </SC.Metrics>
      </SC.ChannelMetricWrapper>
      <TargetMetric minTarget={minTarget} totalTarget={totalTarget} />
    </SC.TargetMetricWrapper>
  );
};

export default PrintMetricsValue;
